import { warnInDev } from "../../../debug";
import { Action, createAction } from "../../actions/Action";
import { wait } from "../../actions/ActionMovement";
import { Actor } from "../Actor";
import aiTraits from "./traits/aiTraits";

export type ActionController = (actor: Actor) => Action<any> | void;

export const priorityController = (actor: Actor) => {
  if (!actor.breed.aiTraits) {
    warnInDev("Actor has priorityController, but no traits");
    return createAction(wait, actor, null);
  }

  let best = 0;
  let bestTrait = null;
  let actionData = null;
  let trait;
  for (let i = 0; i < actor.breed.aiTraits.length; i++) {
    trait = actor.breed.aiTraits[i];
    const traitHandler = aiTraits[trait];
    if (!traitHandler) {
      warnInDev(`No trait handler for ${trait}`);
      return;
    }
    if (best < traitHandler.max) {
      const result = traitHandler.getPriority(actor);
      if (result && best < result[0]) {
        best = result[0];
        actionData = result[1];
        bestTrait = traitHandler;
      }
    }
  }
  if (bestTrait) {
    return bestTrait.getAction(actor, actionData);
  }
  return createAction(wait, actor, null);
};
